import ToggleBtn from "components/toggleBtn/ToggleBtn";

export default ToggleBtn.extend({
    template: require('./toggleBtn.hbs'),
    componentClass: 'toggleBtn',

});


// WEBPACK FOOTER //
// ./src/components/toggleBtn/ToggleBtn.js